const Hamburger = () => (
	<svg width={17} height={11} viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M1.5 0.734039H15.5"
			stroke="currentColor"
			strokeWidth="1.19149"
			strokeLinecap="round"
		/>
		<path d="M1.5 5.5H15.5" stroke="currentColor" strokeWidth="1.19149" strokeLinecap="round" />
		<path d="M1.5 10.266H15.5" stroke="currentColor" strokeWidth="1.19149" strokeLinecap="round" />
	</svg>
)

export default Hamburger
